import React, { useEffect } from 'react';
import { useFormState } from 'react-final-form';
import { RuleSet } from 'styled-components';
import { Divider, ErrorText, ErrorWrapper } from './styled';

interface ErrorFieldProps {
  field: string;
  cypress: string;
  margin?: number | string;
  divider?: boolean;
  styles?: RuleSet<object>;
  setError?: (value: boolean) => void;
  formatError?: (value: string) => void;
}

export const ErrorField: React.FC<ErrorFieldProps> = ({
  field,
  cypress,
  margin = 0,
  divider = true,
  styles,
  setError,
  formatError
}) => {
  const { errors, submitFailed, submitErrors } = useFormState({
    subscription: { errors: true, submitFailed: true, submitErrors: true }
  });
  const isError =
    (submitFailed && errors?.[field]) || (submitErrors && submitErrors[field]);

  useEffect(() => {
    if (setError) {
      setError(Boolean(isError));
    }
  }, [isError]);

  const error = errors?.[field] || submitErrors?.[field] || '';
  const errorMessage = formatError ? formatError(error) : error;

  return (
    <ErrorWrapper $margin={margin} styles={styles}>
      {divider && <Divider data-cy="error-divider" $isError={isError} />}

      {isError && (
        <ErrorText
          tag="body_2"
          data-cy={cypress}
          data-info="item-modal__error-text"
        >
          {errorMessage}
        </ErrorText>
      )}
    </ErrorWrapper>
  );
};
